var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEasyInterface(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121.5,
    height: 121.5,
    viewBox: "0 0 121.5 121.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-interface-2415600",
    transform: "translate(-78.75 -8.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9165",
    "data-name": "Path 9165",
    d: "M190.452,36.185h-1.96V8.75H90.508V36.185h-1.96a9.809,9.809,0,0,0-9.8,9.8v62.71a9.809,9.809,0,0,0,9.8,9.8h25.476v7.839h-7.839v3.919h66.629v-3.919h-7.839v-7.839h25.476a9.809,9.809,0,0,0,9.8-9.8V45.984A9.809,9.809,0,0,0,190.452,36.185ZM141.46,90.956c-.651.047-1.3.1-1.96.1A27.465,27.465,0,0,1,112.065,63.62h3.4a9.394,9.394,0,0,1,8.023,4.564,13.286,13.286,0,0,0,8.766,6.176,9.354,9.354,0,0,1,6.173,4.351l1.7,2.832a9.331,9.331,0,0,1,1.331,4.8Zm2.031-11.429-1.7-2.832a13.286,13.286,0,0,0-8.766-6.176,9.376,9.376,0,0,1-6.192-4.382A13.317,13.317,0,0,0,115.469,59.7h-3.091a27.368,27.368,0,0,1,8.781-16.426l.822,2.74a10.893,10.893,0,0,0,10.5,7.807h3.8a6.086,6.086,0,0,0,5.912-4.615,4.255,4.255,0,0,1,7.449-1.629l3.619,4.527a9.753,9.753,0,0,0,7.651,3.677h4.876a27.293,27.293,0,0,1,.842,3.919H148.363a6.8,6.8,0,0,0-6.792,5.4,6.664,6.664,0,0,0,4.057,7.388l1.464.586a6.59,6.59,0,0,1,4.167,6.151,10.585,10.585,0,0,0,1.113,4.715l1.5,3a27.212,27.212,0,0,1-8.491,3.459v-4.06a13.258,13.258,0,0,0-1.891-6.818ZM124.477,40.689A27.351,27.351,0,0,1,164.25,51.861H160.9a5.851,5.851,0,0,1-4.591-2.2l-3.619-4.525a8.173,8.173,0,0,0-14.312,3.122,2.17,2.17,0,0,1-2.108,1.648h-3.8a6.991,6.991,0,0,1-6.739-5.015ZM157.1,84.637l-1.223-2.446a6.678,6.678,0,0,1-.7-2.962,10.5,10.5,0,0,0-6.628-9.791l-1.464-.586a2.734,2.734,0,0,1-1.658-3.034,2.916,2.916,0,0,1,2.936-2.2h18.571A27.385,27.385,0,0,1,157.1,84.637Zm13.755-21.019c0-.586-.039-1.162-.079-1.738l-.039-.6c-.025-.341-.031-.686-.068-1.023l-.037-.559h-.049a31.326,31.326,0,0,0-62.168,0h-.049l-.038.558c-.035.337-.043.682-.068,1.023l-.039.6c-.038.577-.078,1.153-.078,1.739A31.121,31.121,0,0,0,112.386,79.3H94.425V28.344H184.57V79.3H166.61a31.119,31.119,0,0,0,4.243-15.677Zm13.718-50.952V24.425H94.427V12.666ZM88.548,40.1h1.96V83.215h24.555a31.272,31.272,0,0,0,48.873,0h24.555V40.1h1.96a5.886,5.886,0,0,1,5.879,5.879V98.892H82.669V45.981A5.886,5.886,0,0,1,88.548,40.1Zm72.508,86.226H117.943v-7.839h43.113Zm29.4-11.758H88.548a5.886,5.886,0,0,1-5.879-5.879v-5.879H196.331v5.879A5.886,5.886,0,0,1,190.451,114.57Z",
    fill: "#5fccf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9166",
    "data-name": "Path 9166",
    d: "M498.75,446.25h3.919v3.919H498.75Z",
    transform: "translate(-325.936 -339.516)",
    fill: "#5fccf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9167",
    "data-name": "Path 9167",
    d: "M533.75,446.25h3.919v3.919H533.75Z",
    transform: "translate(-353.097 -339.516)",
    fill: "#5fccf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9168",
    "data-name": "Path 9168",
    d: "M568.75,446.25h3.919v3.919H568.75Z",
    transform: "translate(-380.258 -339.516)",
    fill: "#5fccf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9169",
    "data-name": "Path 9169",
    d: "M166.25,43.75h3.919v3.919H166.25Z",
    transform: "translate(-67.903 -27.161)",
    fill: "#5fccf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9170",
    "data-name": "Path 9170",
    d: "M201.25,43.75h3.919v3.919H201.25Z",
    transform: "translate(-95.065 -27.161)",
    fill: "#5fccf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9171",
    "data-name": "Path 9171",
    d: "M236.25,43.75h3.919v3.919H236.25Z",
    transform: "translate(-122.226 -27.161)",
    fill: "#5fccf2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyInterface);
export default __webpack_public_path__ + "static/media/easyInterface.66cd3007a6288deac1ddf8cae62619dc.svg";
export { ForwardRef as ReactComponent };